import { render, staticRenderFns } from "./FiatShipment.vue?vue&type=template&id=7cbcb4ba"
import script from "./FiatShipment.vue?vue&type=script&lang=js"
export * from "./FiatShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports